"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _actions = require("../actions");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: rgba(0, 0, 0, 0.32);\n"])));

var StyledInner = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 0.5rem 0 1rem;\n"])));

var StyledRow = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1rem;\n  margin-bottom: 1rem;\n"])));

var StyledIndex = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 0 0 18px;\n  margin-right: 1rem;\n  font-size: 1rem;\n  font-weight: 700;\n  width: 18px;\n  height: 18px;\n  border-radius: 0.325rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(255, 255, 255, 0.67);\n"])));

var StyledQuestion = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n"])));

var StyledQuestionText = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 0.325rem;\n  font-size: 0.75rem;\n  line-height: 1.35;\n  color: rgba(255, 255, 255, 0.96);\n"])));

var StyledQuestionAnswer = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.96);\n"])));

var StyledPoints = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  flex: 0 0 26px;\n  height: 26px;\n  font-weight: 700;\n  font-size: 0.75rem;\n  text-align: center;\n  margin-left: 1rem;\n  background: ", ";\n  color: ", ";\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (p) {
  return p.hasPoints ? (0, _polished.rgba)(p.theme.colorLeaderboardPrizeBackground, 0.96) : (0, _polished.rgba)(p.theme.colorLeaderboardButtonBackground, 0.15);
}, function (p) {
  return p.hasPoints ? p.theme.colorLeaderboardPrizeText : (0, _polished.rgba)(p.theme.colorLeaderboardButtonText, 0.2);
});

var StyledOptionList = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  padding-top: 4px;\n  height: 24px;\n"])));

var StyledOptionListItem = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: relative;\n  margin-right: 0.325rem;\n  color: ", ";\n"])), function (p) {
  return p.isCorrect ? "rgba(255, 255, 255, 0.97)" : "rgba(255, 255, 255, 0.25)";
});

var StyledOptionListItemIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 14px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 14px;\n  color: ", ";\n"])), function (p) {
  return p.isCorrect ? (0, _polished.rgba)(p.theme.colorLeaderboardPrizeBackground, 0.96) : (0, _polished.rgba)(p.theme.colorLeaderboardButtonText, 0.25);
});

var StyledButtonWrapper = _styledComponents.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  padding: 0 1rem 1rem;\n"])));

var StyledBlockButton = (0, _styledComponents.default)(_fiverReactUiComponents.BlockButton)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  border-radius: 2rem;\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLeaderboardButtonBackground;
}, function (p) {
  return p.theme.colorLeaderboardButtonText;
});

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      activePickem = _ref.activePickem,
      activeBet = _ref.activeBet,
      table = _ref.table,
      setBetbar = _ref.setBetbar;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.leaderboard;
  }),
      activeUserBet = _useSelector.activeUserBet,
      isShowingMyBet = _useSelector.isShowingMyBet;

  var questions = activePickem.questions;
  var selections = activeUserBet ? activeUserBet.selections : {};

  var getListQuestionAnswer = function getListQuestionAnswer(options, id) {
    var answerId = selections === null || selections === void 0 ? void 0 : selections[id];
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledOptionList, {
      children: options.map(function (opt, i, arr) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledOptionListItem, {
          isSelected: opt.id === answerId,
          isCorrect: opt.points,
          children: [opt.label === "Yes" ? translations.yes : opt.label === "No" ? translations.no : opt.label, opt.id === answerId && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledOptionListItemIcon, {
            isCorrect: opt.points,
            children: "navigation"
          }), i === arr.length - 1 ? "" : ", "]
        });
      })
    });
  };

  var getQuestionAnswer = function getQuestionAnswer(options, id) {
    var _options$find;

    var answerId = selections === null || selections === void 0 ? void 0 : selections[id];
    var label = options === null || options === void 0 ? void 0 : (_options$find = options.find(function (obj) {
      return obj.id === answerId;
    })) === null || _options$find === void 0 ? void 0 : _options$find.label;

    if (label) {
      return answerId ? label === "Yes" ? translations === null || translations === void 0 ? void 0 : translations.yes : label === "No" ? translations === null || translations === void 0 ? void 0 : translations.no : label : "-";
    } else {
      return label;
    }
  };

  var hasPoints = function hasPoints(options, id) {
    var _options$find2;

    var answerId = selections === null || selections === void 0 ? void 0 : selections[id];
    return answerId ? (options === null || options === void 0 ? void 0 : (_options$find2 = options.find(function (obj) {
      return obj.id === answerId;
    })) === null || _options$find2 === void 0 ? void 0 : _options$find2.points) > 0 : false;
  };

  var handleStopFilteringMyBetClicked = function handleStopFilteringMyBetClicked() {
    window.scrollTo(0, 0);
    dispatch((0, _actions.setLeaderboard)({
      activeUserBet: undefined,
      isShowingMyBet: false
    }));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledInner, {
      children: questions === null || questions === void 0 ? void 0 : questions.map(function (q, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRow, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIndex, {
            children: index + 1
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledQuestion, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledQuestionText, {
                children: q.label
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledQuestionAnswer, {
                children: q.options.length > 2 ? getListQuestionAnswer(q.options, q.id) : getQuestionAnswer(q.options, q.id)
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPoints, {
              hasPoints: hasPoints(q.options, q.id),
              children: q.availablePoints
            })]
          })]
        });
      })
    }), isShowingMyBet && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBlockButton, {
        isAccent: true,
        onClick: handleStopFilteringMyBetClicked,
        children: translations.leaderboard
      })
    })]
  });
};

var _default = Wrapper;
exports.default = _default;